import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useHistory } from 'react-router-dom';
import LoadingModal from 'components/shared/LoadingModal';
import { useStores } from 'hooks';
import { Content } from 'assets/ContainerStyles';
import { ROUTES } from '../../shared/constants/index';
import { BodyContent } from './Styles';
import queryString from "query-string";
import {getActiveAuctions} from "../../shared/utils/localStorage";
const Login = () => {
  const {
    MultiAuctionStore: { connected, setProperty },
    DataStore: { addNewConnection, reconnectionErrorMessage, reconnecting },
  } = useStores();

  const [error, setError] = useState(null);

  const history = useHistory();
  const qs = queryString.parse(window.location.search);

  const logOut = () => {
      window.localStorage.clear();
      window.close();
  }

  const initConnection = async () => {
      const normalizedQs = Object.keys(qs).reduce((acc, key) => {
          acc[key.toLowerCase()] = qs[key];
          return acc;
      }, {});

      const {auctionreferenceid, token, lanereferenceid, state} = normalizedQs;
      const qsAuctionReferenceId = auctionreferenceid;
      const qsLaneRefId = lanereferenceid;

      if (!qsLaneRefId || !token) {
          return;
      }

      const tokens = window.localStorage.getItem('auctionTokens');

      /** If there are no active auction in storage, clear everything to ensure no expired auctions remain */
      const auctions = getActiveAuctions(8);
      if (!auctions?.length) {
          window.localStorage.clear();
      }

      if (!JSON.stringify(tokens).includes(token)) {
          // window.localStorage.clear();
          window.localStorage.setItem('hasVisitedLogin', 'true');
      }

      if (state === "expired") {
          setProperty('connected', false);
          localStorage.clear();
          setError("Session Expired. Please login again.");
          return;
      }

      if (!qsLaneRefId) {
          setError('Missing Lane ID');
          return;
      }

      if (!qsAuctionReferenceId) {
          setError('Missing Auction ID');
          return;
      }

      // Add the auction to the MultiAuctionStore
      //addAuction(qsAuctionReferenceId, {}, providerStore);

      const res  = await addNewConnection({key: qsAuctionReferenceId, token, auctionID: qsAuctionReferenceId, laneID: qsLaneRefId});

      if (res?.error && !res?.success) {
          setError(error);
      }
  }

    useEffect(() => {
        if (connected && !reconnecting) {
            setError(null);
            history.push(`${ROUTES.auction}`);
        }

    }, [connected, reconnecting]);

  useEffect(() => {
      if (!connected) {
          localStorage.clear();
          initConnection();
      }
  }, [qs, connected]);

    if (reconnecting) {
        return <LoadingModal />;
    }

    if (error) {
        return (
            <Content>
                <BodyContent>
                    <h1>Unable to connect</h1>
                    <p>{error}</p>
                </BodyContent>
            </Content>
        );
    }

    if (!reconnecting && reconnectionErrorMessage) {
        return (
            <>
                <Content>
                    <BodyContent>
                        <h1>Unable to connect</h1>
                        <p>{reconnectionErrorMessage || 'Try refreshing your browser or logging in again'}</p>
                        <p>
                            <button
                                type="button"
                                style={{
                                    color: 'var(--utilityBtnTextColor)',
                                    backgroundColor: 'var(--utilityBtnBgColor)',
                                }}
                                onClick={() => history.go()}
                            >
                                Refresh
                            </button>
                        </p>
                    </BodyContent>
                </Content>
            </>
        );
    }

  return (
      <Content>
          <BodyContent>
              <h1>Session Expired</h1>
              <button
                  type="button"
                  style={{
                      color: 'var(--utilityBtnTextColor)',
                      backgroundColor: 'var(--utilityBtnBgColor)',
                  }}
                  onClick={logOut}
              >
                  Please Login
              </button>

          </BodyContent>
      </Content>
  );
};

export default observer(Login);
